import { ChapterItem } from './interfaces';

class ChapterNavigation {
	private chapterLinks: Array<HTMLAnchorElement>;
	private chapterSelect: HTMLSelectElement;
	private chapterItems: Array<ChapterItem>;
	private currentChapterItem: ChapterItem;
	private threshold: number;

	constructor() {
		const chapterNavigation: HTMLElement = document.querySelector('.chapter-navigation');

		if (!chapterNavigation) {
			return;
		}

		this.chapterSelect = document.querySelector('.chapter-select select');
		this.chapterSelect.addEventListener('input', this.onSelectInput);

		this.threshold = parseInt(
			window.getComputedStyle(document.querySelector('.sticky-container')).top
		);
		this.chapterLinks = [];
		this.chapterItems = [];
		this.currentChapterItem = null;

		chapterNavigation.querySelectorAll('a').forEach((item) => {
			const url: URL = new URL(item.href);
			const index: string = decodeURI(url.hash.substring(1));
			this.chapterLinks[index] = item;
		});

		document.querySelectorAll('[data-chapter-name]').forEach((chapterItem: HTMLElement) => {
			this.chapterItems.push({
				element: chapterItem,
				positionTop: ChapterNavigation.cumulativeOffset(chapterItem),
			});
		});

		this.chapterItems.reverse();

		document.addEventListener('scroll', this.onScroll, { passive: true });
		window.addEventListener('resize', this.recalculateElementPositions, { passive: true });

		this.onScroll();
	}

	private onSelectInput = (): void => {
		this.chapterLinks[this.chapterSelect.value]?.click();
	};

	private recalculateElementPositions = (): void => {
		this.chapterItems.forEach((chapterItem) => {
			chapterItem.positionTop = ChapterNavigation.cumulativeOffset(chapterItem.element);
		});

		this.onScroll();
	};

	private static cumulativeOffset(element: HTMLElement): number {
		let top: number = 0;
		do {
			top += element.offsetTop || 0;
			element = element.offsetParent as HTMLElement;
		} while (element);

		return top;
	}

	private onScroll = () => {
		const currentItem: ChapterItem = this.chapterItems.find(
			(chapterItem) => window.scrollY > chapterItem.positionTop - this.threshold
		);

		if (!currentItem && this.currentChapterItem) {
			this.chapterLinks[this.currentChapterItem.element.id].classList.remove('active');
			this.currentChapterItem = null;
			this.chapterSelect.value = 'pillar-content';
		}

		if (currentItem && currentItem !== this.currentChapterItem) {
			if (this.currentChapterItem) {
				this.chapterLinks[this.currentChapterItem.element.id].classList.remove('active');
			}

			this.currentChapterItem = currentItem;
			this.chapterLinks[this.currentChapterItem.element.id].classList.add('active');

			this.chapterSelect.value = this.currentChapterItem.element.id;
		}
	};
}

new ChapterNavigation();
